// extracted by mini-css-extract-plugin
export var allParagraph = "Text-allParagraph-i0+qY";
export var center = "Text-center-QAwQK";
export var left = "Text-left-BRLig";
export var right = "Text-right-zdht3";
export var textLgRegular = "Text-textLgRegular-SriET";
export var textSmRegular = "Text-textSmRegular--wCzj";
export var textXlRegular = "Text-textXlRegular-cELib";